/* The homepage print-in language, shared with the other editorial pages.
   Group order: 60 ms; stamp .45 s; drop .5 s; band .45 s plus .15 s.
   Only decorative marks, selected headings and imagery receive new hooks.
   Prices, fields, totals and checkout controls are never added here. */
(() => {
  if (window.CollectorsGuildReveal || !('IntersectionObserver' in window)) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  // Shopify supplies native page/policy prose as HTML. Mark its headings only;
  // leave the prose, policy facts and any embedded form untouched.
  document.querySelectorAll('[data-cg-motion-reading] :is(h2,h3), .shopify-policy__body :is(h2,h3)').forEach(heading => {
    if (!heading.closest('form') && !heading.hasAttribute('data-cg-reveal')) heading.dataset.cgRevealSelf = 'band';
  });
  const groups = [...document.querySelectorAll('[data-cg-reveal-group], [data-cg-reveal-self]')];
  if (!groups.length) return;
  const onScreen = el => { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; };
  const observer = new IntersectionObserver(entries => {
    const arriving = entries.filter(entry => entry.isIntersecting)
      .sort((a, b) => (a.boundingClientRect.top - b.boundingClientRect.top) || (a.boundingClientRect.left - b.boundingClientRect.left));
    arriving.forEach((entry, i) => {
      if (entry.target.hasAttribute('data-cg-reveal-self')) entry.target.style.setProperty('--cg-reveal-i', String(Math.min(i, 8)));
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.15 });
  groups.forEach(group => {
    if (reduce.matches || onScreen(group)) { group.classList.add('is-in'); return; }
    const parts = group.hasAttribute('data-cg-reveal-children') ? [...group.children] : [...group.querySelectorAll('[data-cg-reveal]')];
    parts.forEach((el, i) => el.style.setProperty('--cg-reveal-i', String(Math.min(i, 10))));
    observer.observe(group);
  });
  if (!reduce.matches) document.documentElement.classList.add('cg-reveal-ready');
  reduce.addEventListener('change', () => {
    if (!reduce.matches) return;
    observer.disconnect();
    groups.forEach(group => group.classList.add('is-in'));
    document.documentElement.classList.remove('cg-reveal-ready');
  });
  window.CollectorsGuildReveal = { snapshot: () => ({ groups: groups.length, waiting: groups.filter(group => !group.classList.contains('is-in')).length, reduced: reduce.matches }) };
})();
